import React from 'react'
import { Link } from 'react-router-dom'

import { conicWash, orbRing, paletteFor } from '../orbPalettes'

import DirectionPill from './DirectionPill'

// One agent, as a card. Everything shown is real data from GET /voice-agents —
// no field here required a schema change.
//
// Two things from the design mock are deliberately absent. The Active/Paused/
// Deactivated status pill: no system records an agent's operating status
// (AVR-556 open question 2). And the Created date: `voice_agents` carries no
// timestamps, so the only candidate was the prompt config's `seeded_at`, which
// dates the config rather than the agent — close enough to mislead.
const AgentCard = ({ agent, to }) => {
  const palette = paletteFor(agent.orbKey)
  const isOutbound = agent.direction === 'outbound'

  const body = (
    <>
      {/* No agent-id chip: an opaque Cartesia id isn't information a customer
          browsing their agents can act on, and the agent page's header already
          shows it with a proper copy button for when it is needed. */}
      <div className="voice-agents-card__head">
        {/* Two elements rather than one background: the wash is blurred to melt
            the wedge seams, and blurring the orb itself would soften its outer
            edge into the card. The wrapper clips a hard circle; the wash bleeds
            past it so the blur has colour to pull from instead of transparency. */}
        <span
          className="voice-agents-card__orb"
          style={{ boxShadow: orbRing(palette) }}
          aria-hidden="true"
        >
          <span
            className="voice-agents-card__orb-wash"
            style={{ background: conicWash(palette, 32) }}
          />
        </span>
        <span className="voice-agents-card__name">{agent.name}</span>
      </div>

      {agent.description && <p className="voice-agents-card__description">{agent.description}</p>}

      {/* Footer is pinned to the bottom of the card, so the metadata lands in
          the same place on every card regardless of how long the description
          above it is. */}
      <div className="voice-agents-card__footer">
        <span className="voice-agents-card__updated">
          {agent.lastUpdated ? `Updated ${agent.lastUpdated}` : null}
        </span>
        {/* Campaign count is outbound-only: an inbound agent has no campaigns by
            definition, so "0 campaigns" there would read as a problem rather
            than as not-applicable. */}
        {isOutbound && (
          <span className="voice-agents-card__campaigns">
            {agent.campaignCount === 1 ? '1 campaign' : `${agent.campaignCount} campaigns`}
          </span>
        )}
        {agent.direction && <DirectionPill direction={agent.direction} size="xs" />}
      </div>
    </>
  )

  // Viewers without edit access get the same card without the navigation — the
  // agent page is gated for them, so a link would only 403.
  if (!to) {
    return (
      <div className="voice-agents-card" data-testid="voice-agent-card">
        {body}
      </div>
    )
  }

  return (
    <Link className="voice-agents-card" to={to} data-testid="voice-agent-card">
      {body}
    </Link>
  )
}

export default AgentCard
